module.exports = __webpack_public_path__ + "media/public/fonts/QanelasBold/QanelasBold-a5e9ac10ed834f1168380f48af1b78ef.eot";